import { ALL_PET_TYPES_FOR_NEWSLETTER } from '@/utils/pet-types';

type Country = {
  isocode: string;
  name: string;
};

type PetType = {
  uid: string;
};

export const useFormOptions = () => {
  const store = useMainStore();
  const { $i18n } = useNuxtApp();

  return {
    billingCountries() {
      return this.getCountryOptions(store.billingCountries);
    },

    shippingCountries() {
      return this.getCountryOptions(store.shippingCountries);
    },

    petTypes(newsletter = false, sortedPetTypes = []) {
      let options = [];

      if (newsletter) {
        const petTypes = ALL_PET_TYPES_FOR_NEWSLETTER;

        for (let i = 0; i < petTypes.length; i += 1) {
          const petType = petTypes[i];

          options.push({
            icon: $i18n.t(`pets.icons.${petType}`),
            label: $i18n.t(`pets.types.${petType}`),
            value: petType,
          });
        }
      }

      if (sortedPetTypes.length) {
        options = sortedPetTypes.map((petType: PetType) => ({
          icon: $i18n.t(`pets.icons.${petType.uid}`),
          label: $i18n.t(`pets.types.${petType.uid}`),
          value: petType.uid,
        }));
      }

      return options;
    },
    getCountryOptions(countries: Country[]) {
      const options = [];

      for (let i = 0; i < countries.length; i += 1) {
        const country = countries[i];

        options.push({
          value: country.isocode,
          label: country.name || country.isocode,
        });
      }

      return options;
    },
  };
};
